import React from "react";

import * as Styled from "./styles";

interface Props {
  active: boolean;
  title: string;
  onClick: () => void;
}

const RiskButton: React.FC<Props> = ({ active, onClick, title }) => (
  <Styled.Container
    variant="contained"
    size="small"
    text={title}
    active={active}
    onClick={onClick}
    disabled={!active}
  />
);

export default RiskButton;
